<div
  #origin
  id="user-info"
  [ngClass]="{
    purple: userWrapperClass === subscriptionBrandingColor.Purple,
    gold: userWrapperClass === subscriptionBrandingColor.Gold,
    'user-wrapper': true,
    'wrapper-loading': userInitialsBackgroundLoading
  }"
  (click)="onOpenMenu(rootListContent, origin)"
>
  {{ shortName$ | async }}
</div>

<div *ngIf="userInitialsBackgroundLoading" class="ghost-active-fluid">&nbsp;</div>

<ng-template #rootListContent>
  <div class="menu-content" [class.mobile]="isMobile">
    <div class="deck-header">
      <div class="client-info">
        <div class="ui dropdown user-wrapper" [ngClass]="userWrapperClass">
          {{ shortName$ | async }}
        </div>
        <div class="user-details">
          <span class="user-name">{{ userName$ | async }}</span>
          <span class="user-email">{{ userEmail$ | async }}</span>
          <span class="company-name">{{ companyName$ | async }}</span>
        </div>
      </div>
    </div>
    <div class="menu-items" [class.mobile]="isMobile">
      <div
        class="menu-item"
        data-item-name="settings"
        (click)="onOpenMenu(settingsContent, origin)"
        data-lokalise
        data-key="txt_settings"
      ></div>
      <div
        class="menu-item"
        data-item-name="billing"
        (click)="onOpenMenu(billingContent, origin)"
        data-lokalise
        data-key="txt_billing"
      ></div>
      <div
        data-item-name="plans"
        *ngIf="!(isGelatoUser$ | async)"
        class="menu-item"
        (click)="onOpenMenu(plansContent, origin)"
        data-lokalise
        data-key="txt_plans"
      ></div>
      <div class="menu-item">
        <gd-auth-button-mobile></gd-auth-button-mobile>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #plansContent>
  <h3 class="menu-section-title">
    <img
      class="back-icon"
      src="assets/icons/arrow-left-black.svg"
      width="32"
      height="32"
      (click)="onOpenMenu(rootListContent, origin)"
    />
    {{ 'txt_plans' | translate }}
  </h3>
  <hr class="separator" />
  <div class="menu-items">
    <div
      class="menu-item"
      data-item-name="view-plans"
      [routerLink]="['/growth-plans']"
      (click)="onCloseSwitcher()"
      data-lokalise
      data-key="txt_view_plans"
    ></div>
    <div
      class="menu-item"
      data-item-name="manage-subscriptions"
      (click)="onManageSubscriptionClick()"
      data-lokalise
      data-key="txt_manage_subscription"
    ></div>
  </div>
</ng-template>

<ng-template #billingContent>
  <h3 class="menu-section-title">
    <img
      class="back-icon"
      src="assets/icons/arrow-left-black.svg"
      width="32"
      height="32"
      (click)="onOpenMenu(rootListContent, origin)"
    />
    {{ 'txt_billing' | translate }}
  </h3>
  <hr class="separator" />
  <div class="menu-items">
    <div
      *ngIf="authService.hasReadPermission('billing', 'resale-certificate')"
      class="menu-item"
      [routerLink]="['/tax-center']"
      (click)="onCloseSwitcher()"
      data-lokalise
      data-key="txt_tax_center"
    ></div>
    <div
      *ngIf="(authService.hasReadPermission('billing', 'stored-payment-method') | async) && !(isGelatoUser$ | async)"
      class="menu-item"
      [routerLink]="['/currency']"
      (click)="onCloseSwitcher()"
      data-lokalise
      data-key="txt_currency"
    ></div>
    <div
      *ngIf="(authService.hasWritePermission('billing', 'stored-payment-method') | async) && isPrepaidAccount$ | async"
      class="menu-item"
      cy-data="billing-payment-menu-item"
      [routerLink]="['/payment-methods/wallets']"
      (click)="onCloseSwitcher()"
    >
      {{ 'txt_payment' | translate }}
    </div>
    <div
      *ngIf="!(isGelatoUser$ | async)"
      class="menu-item"
      (click)="onManageSubscriptionClick()"
      data-lokalise
      data-key="txt_manage_subscription"
    ></div>
  </div>
</ng-template>

<ng-template #settingsContent>
  <h3 class="menu-section-title">
    <img
      class="back-icon"
      src="assets/icons/arrow-left-black.svg"
      width="32"
      height="32"
      (click)="onOpenMenu(rootListContent, origin)"
    />
    {{ 'txt_settings' | translate }}
  </h3>
  <hr class="separator" />
  <div class="menu-items">
    <div
      class="menu-item"
      data-item-name="profile"
      [routerLink]="['/users/edit', userId$ | async]"
      (click)="onCloseSwitcher()"
      data-lokalise
      data-key="txt_profile"
    ></div>
    <div
      class="menu-item"
      data-item-name="language-and-currency"
      (click)="onOpenMenu(languageAndCurrencyContent, origin)"
      data-lokalise
      data-key="txt_language_and_currency"
    ></div>
    <div
      *ngIf="(authService.hasWritePermission('billing', 'company-details') | async) && !(isGelatoUser$ | async)"
      class="menu-item"
      data-item-name="company"
      [routerLink]="['/company-info']"
      (click)="onCloseSwitcher()"
      data-lokalise
      data-key="txt_company"
    ></div>
    <div
      *ngIf="(authService.hasReadPermission('identity', 'user') | async) && !(isGelatoUser$ | async)"
      class="menu-item"
      data-item-name="users"
      [routerLink]="['/users/list']"
      (click)="onCloseSwitcher()"
      data-lokalise
      data-key="txt_users"
    ></div>
  </div>
</ng-template>

<ng-template #languageAndCurrencyContent>
  <h3 class="menu-section-title">
    <img
      class="back-icon"
      src="assets/icons/arrow-left-black.svg"
      width="32"
      height="32"
      (click)="onOpenMenu(settingsContent, origin)"
    />
    {{ 'txt_language_and_currency' | translate }}
  </h3>
  <hr class="separator" />
  <div class="menu-items">
    <div class="menu-item" data-item-name="language-switcher" (click)="onOpenMenu(langListContent, origin)">
      {{ 'txt_language_switcher' | translate }}
      <ng-container *ngIf="currentLocale">- {{ currentLocale.nameShort }}</ng-container>
    </div>
    <div class="menu-item" data-item-name="currency-switcher" (click)="onOpenMenu(currencyListContent, origin)">
      {{ 'txt_currency' | translate }}
      <ng-container *ngIf="userCurrency$ | async">- {{ userCurrency$ | async }}</ng-container>
    </div>
  </div>
</ng-template>

<ng-template #langListContent>
  <h3 class="menu-section-title">
    <img
      class="back-icon"
      src="assets/icons/arrow-left-black.svg"
      width="32"
      height="32"
      (click)="onOpenMenu(languageAndCurrencyContent, origin)"
    />
    {{ 'txt_language_switcher' | translate }}
  </h3>
  <hr class="separator" />
  <div class="menu-items">
    <div
      *ngFor="let lang of languagesList"
      class="menu-item"
      [attr.data-item-name]="lang.code"
      (click)="onChangeLocaleCode(lang.code)"
      [class.selected]="currentLocale.code === lang.code"
    >
      {{ lang.name }}
    </div>
  </div>
</ng-template>

<ng-template #currencyListContent>
  <h3 class="menu-section-title">
    <img
      class="back-icon"
      src="assets/icons/arrow-left-black.svg"
      width="32"
      height="32"
      (click)="onOpenMenu(languageAndCurrencyContent, origin)"
    />
    {{ 'txt_currency' | translate }}
  </h3>
  <hr class="separator" />
  <div class="menu-items">
    <div
      *ngFor="let currency of currenciesList"
      class="menu-item"
      [attr.data-item-name]="currency.code"
      (click)="onChangeCurrency(currency.code)"
      [class.selected]="(userCurrency$ | async) === currency.code"
    >
      {{ currency.title }} - {{ currency.code }}
    </div>
  </div>
</ng-template>
